export const RECAPTCHA_SITE_KEY = '6LfENu4qAAAAAFtPejcrP3dwBDxcRPjqi7RhytJJ';
export const RECAPTCHA_ACTION = 'password_reset';

type Grecaptcha = {
  ready: (callback: () => void) => void;
  execute: (siteKey: string, options: { action: string }) => Promise<string>;
};

declare global {
  interface Window {
    grecaptcha?: Grecaptcha;
  }
}

let loading: Promise<void> | null = null;

export function loadRecaptcha(siteKey: string = RECAPTCHA_SITE_KEY): Promise<void> {
  if (window.grecaptcha) {
    return Promise.resolve();
  }
  if (loading && document.querySelector('script[data-recaptcha-v3="true"]')) {
    return loading;
  }

  loading = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(siteKey)}`;
    script.async = true;
    script.dataset.recaptchaV3 = 'true';
    script.onload = () => resolve();
    script.onerror = () => {
      loading = null;
      script.remove();
      reject(new Error('reCAPTCHA failed to load'));
    };
    document.head.appendChild(script);
  });
  return loading;
}

export async function executePasswordResetCaptcha(
  siteKey: string = RECAPTCHA_SITE_KEY
): Promise<string> {
  await loadRecaptcha(siteKey);
  const grecaptcha = window.grecaptcha;
  if (!grecaptcha) {
    throw new Error('reCAPTCHA unavailable');
  }

  await new Promise<void>((resolve) => {
    grecaptcha.ready(resolve);
  });

  const token = await grecaptcha.execute(siteKey, { action: RECAPTCHA_ACTION });
  if (!token) {
    throw new Error('empty reCAPTCHA token');
  }
  return token;
}
